import { render, staticRenderFns } from "./ManageTagsModal.vue?vue&type=template&id=68420e6a&scoped=true"
import script from "./ManageTagsModal.vue?vue&type=script&lang=js"
export * from "./ManageTagsModal.vue?vue&type=script&lang=js"
import style0 from "./ManageTagsModal.vue?vue&type=style&index=0&id=68420e6a&scoped=true&lang=css"
import style1 from "./ManageTagsModal.vue?vue&type=style&index=1&id=68420e6a&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68420e6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68420e6a')) {
      api.createRecord('68420e6a', component.options)
    } else {
      api.reload('68420e6a', component.options)
    }
    module.hot.accept("./ManageTagsModal.vue?vue&type=template&id=68420e6a&scoped=true", function () {
      api.rerender('68420e6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manageTag/ManageTagsModal.vue"
export default component.exports